import React from 'react';
import {Avatar, CardActionArea, CardContent, CardHeader, Tooltip, Typography} from "@mui/material";
import {capitalizeWords} from "../../../../utils/GenericUtils";
import Grid from "@mui/material/Grid";
import moment from "moment";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";

const AnagraficaCard = ({anagrafica, onClickDetail}) => {
	return (
		<React.Fragment>
			<Tooltip title={"Clicca per andare al dettaglio del paziente"}>
				<CardActionArea onClick={() => onClickDetail(anagrafica)}>
					<CardHeader
						style={{paddingBottom: 2}}
						avatar={
							<Avatar>
								<SVG src={multiavatar(anagrafica?.codF)}/>
							</Avatar>
						}
						title={
							<Typography variant={"subtitle1"} style={{position: "relative"}}>
								{anagrafica.nome && <b>{capitalizeWords(anagrafica.nome)}</b>} {" "}
								{anagrafica.cognome && <b>{capitalizeWords(anagrafica.cognome)}</b>}
							</Typography>
						}
					/>
					<CardContent style={{paddingTop: 8}}>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={3}>
								<Typography variant={"body2"} color={"textSecondary"}>
									{anagrafica.tipoDocumento ? anagrafica.tipoDocumento : "Codice fiscale"}
								</Typography>
								<Typography variant={"body2"} color={"textSecondary"}>
									<b>{(anagrafica.codF ? anagrafica.codF.toUpperCase() : anagrafica.documento ? anagrafica.documento : "--")}</b>
								</Typography>
							</Grid>
							<Grid item xs={12} sm={3}>
								<Typography variant={"body2"} color={"textSecondary"}>
									Nato il
								</Typography>
								<Typography variant={"body2"} color={"textSecondary"}>
									<b>{anagrafica.dataNascita ? moment(anagrafica.dataNascita).format("DD/MM/YYYY") : "--"}</b>
								</Typography>
							</Grid>
							<Grid item xs={12} sm={3}>
								<Typography variant={"body2"} color={"textSecondary"}>
									Nel comune
								</Typography>
								<Typography variant={"body2"} color={"textSecondary"}>
									<b>{anagrafica.comuneNascita ? anagrafica.comuneNascita : "--"}</b>
								</Typography>
							</Grid>
							<Grid item xs={12} sm={3}>
								<Typography variant={"body2"} color={"textSecondary"}>
									Indirizzo
								</Typography>
								<Typography variant={"body2"} color={"textSecondary"}>
									<b>{anagrafica.indirizzoResidenza ? anagrafica.indirizzoResidenza : "--"}, {anagrafica.indirizzoDomicilio ? anagrafica.indirizzoDomicilio : "--"}</b>
								</Typography>
							</Grid>
							
							<Grid item xs={12} sm={3}>
								<Typography variant={"body2"} color={"textSecondary"}>
									Contatto telefonico
								</Typography>
								<Typography variant={"body2"} color={"textSecondary"}>
									<b>{anagrafica.cell ? anagrafica.cell.replaceAll(" ", "").replaceAll("+39", "+39 ") : "--"}</b>
								</Typography>
							</Grid>
							<Grid item xs={12} sm={3}>
								<Typography variant={"body2"} color={"textSecondary"}>
									Contatto email
								</Typography>
								<Typography variant={"body2"} color={"textSecondary"}>
									<b>{anagrafica.email ? anagrafica.email.replaceAll(" ", "") : "--"}</b>
								</Typography>
							</Grid>
							<Grid item xs={12} sm={3}>
								<Typography variant={"body2"} color={"textSecondary"}>
									ASL di residenza
								</Typography>
								<Typography variant={"body2"} color={"textSecondary"}>
									<b>{anagrafica.resASL ? anagrafica.resASL : "--"}</b>
								</Typography>
							</Grid>
							<Grid item xs={12} sm={3}>
								<Typography variant={"body2"} color={"textSecondary"}>
									ASL di domicilio
								</Typography>
								<Typography variant={"body2"} color={"textSecondary"}>
									<b>{anagrafica.domASL ? anagrafica.domASL : "--"}</b>
								</Typography>
							</Grid>
						</Grid>
					</CardContent>
				</CardActionArea>
			</Tooltip>
		</React.Fragment>
	);
};

export default React.memo(AnagraficaCard)
